import {ProcessDatePicker} from "components";

import {useFormContext, Controller} from "react-hook-form";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  index: number;
  disabled: boolean;
};

const VoyageBindingDateField = (props: Props) => {
  const {index, disabled} = props;
  const {control} = useFormContext<Process>();

  return (
    <Controller
      name={
        `boarding.voyages.${index}.bindingDate` as `boarding.voyages.0.bindingDate`
      }
      control={control}
      render={({field: {value}}) => (
        <ProcessDatePicker
          value={value}
          name={`boarding.voyages.${index}.bindingDate`}
          errorName="Binding Date"
          title={`Vinculação DTA viagem ${index + 1}`}
          disabled={disabled}
          fullWidth
          label="Vinculação DTA"
        />
      )}
    />
  );
};

export default VoyageBindingDateField;
